module.exports = __webpack_public_path__ + "img/01b-autenticacao.4e9804c6.png";